async function fetchJson(input, init) {
  const response = await fetch(input, init);
  return response.json();
}
export default fetchJson;
